import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { listVndlyCandidateIssues } from 'api/admin/vndly/listVndlyCandidateIssues'
import { vndlyKeys } from './keys'

export function useVndlyCandidateIssuesQuery(
  request: Parameters<typeof listVndlyCandidateIssues>[0]
) {
  return useQuery({
    queryKey: vndlyKeys.candidateIssuesList(request),
    queryFn: () => listVndlyCandidateIssues(request),
    placeholderData: keepPreviousData,
  })
}
